import $ from 'jquery';
import Util from 'root/module/util';
import Cache from 'root/cache';
import UI from 'root/ui';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    project_emails: null,

    events: {
        'click .box-url-share-small'      : 'onCopyEmail',
        'click .public-forwarding-toggle' : 'onTogglePublicForwarding',
        'click .account-upgrade'          : 'onUpgradeAccount',
        'click .project-email-add'        : 'onAddProjectEmail',
        'click .project-email-remove'     : 'onRemoveProjectEmail',
        'click .project-email-save'       : 'onSaveProjectEmail',
        'input .multiple-input input'     : 'onCheckChanges'
    },

    dom_handlers: {
        onCopyEmail: function(e) {
            e.preventDefault();

            Util.copyText(this.model.getForwardingEmail(), () => {
                UI.success('Email copied to clipboard');
            });
        },

        onTogglePublicForwarding: function(e) {
            var allow_public_email_forwarding = !this.model.get('allow_public_email_forwarding');

            this.$el.find('.public-forwarding-toggle')
                .removeClass('switch-on switch-off')
                .addClass(allow_public_email_forwarding ? 'switch-off' : 'switch-on');

            Cache.app.request({
                action: 'project/update',
                data: {
                    project_id: this.model.id,
                    allow_public_email_forwarding: allow_public_email_forwarding
                },
                success: () => {
                    this.model.set('allow_public_email_forwarding', allow_public_email_forwarding);

                    UI.success('Public email forwarding ' + (allow_public_email_forwarding ? 'enabled' : 'disabled'));
                }
            });
        },

        onUpgradeAccount: function () {
            Modals.choosePlan();
        },

        onAddProjectEmail: function(e) {
            var new_input = this.getEmailInputTemplate('');

            $(new_input)
                .insertAfter(this.$el.find('.multiple-input:last'))
                .focus();

            this.checkChanges();
        },

        onRemoveProjectEmail: function(e) {
            if (this.$el.find('.multiple-input').length > 1) {
                $(e.currentTarget).parents('.multiple-input:first').remove();
            } else {
                this.$el.find('.multiple-input input').val('');
            }

            this.checkChanges();
        },

        onCheckChanges: function(e) {
            this.checkChanges();
        },

        onSaveProjectEmail: function(e) {
            this.save();
        }
    },

    loadProjectEmail: function() {
        Cache.app.request({
            action: 'project_email/search',
            data: {
                project_id: this.model.id
            },
            success: (response) => {
                this.project_emails = response;
                this.render();
            }
        });
    },

    // enable the save button if there are changes
    checkChanges: function() {
        this.$el.find('.project-email-save').prop('disabled', false);

        var project_emails = this.getProjectEmails();
        var current_project_emails = this.project_emails.map((email) => email.value);
        var has_changes = project_emails.sort().join(',') !== current_project_emails.sort().join(',');

        this.$el.find('.project-email-save').prop('disabled', !has_changes);
    },

    // get emails from the UI
    getProjectEmails: function(validate) {
        var project_emails = [];
        this.$el.find('.multiple-input input').each((index, input) => {
            var value = $(input).val().trim();

            if (validate) {
                $(input).next('.text-danger').hide();
            }

            if (Util.isNumeric(value)) {
                // user id
                project_emails.push(parseInt(value, 10));
            } else {
                if (Util.isValidEmail(value)) {
                    // email
                    project_emails.push(value);
                } else if (Util.isValidEmail('someone@' + value)) {
                    // domain
                    project_emails.push(value);
                } else {
                    if (validate && value) {
                        $(input).next('.text-danger').show();
                    }
                }
            }
        });

        return project_emails;
    },

    save: function() {
        var project_emails = this.getProjectEmails(true);
        var has_error = this.$el.find('.text-danger:visible').length > 0;

        if (has_error) {
            return;
        }

        this.$el.find('.project-email-save').prop('disabled', true).addClass('loading');

        Cache.app.request({
            action: 'project_email/update',
            data: {
                project_id: this.model.id,
                project_emails: JSON.stringify(project_emails)
            },
            success: (response) => {
                this.project_emails = response;

                UI.success('Email settings saved successfully');
            },
            complete: () => {
                this.$el.find('.project-email-save').removeClass('loading');
            }
        });
    },

    getEmailInputTemplate: function(value) {
        return '' +
        '<div class="multiple-input">' +
            '<div>' +
                '<button type="button" class="project-email-remove text-icon"><i class="fa-solid fa-circle-minus"></i></button>' +
            '</div>' +
            '<div>' +
                '<input type="text" class="solid compact" placeholder="mycompany.com or someone@mycompany.com" value="' + Util.htmlEntities(value) + '">' +
                '<div class="text-danger margin-top-4 text-medium" style="display:none;">Invalid email or domain</div>' +
            '</div>' +
        '</div>';
    },

    render: function() {
        var content =
        '<form class="project-settings-inner-large form-fluid">' +
            '<p>You can send or forward emails to this address to create feedback:</p>' +
            (Cache.account.hasFeature('email_forwarding') ?
            '<div class="box-url-share-small margin-top-8">' +
            Util.htmlEntities(this.model.getForwardingEmail()) +
            '</div>' :
            '<div class="box-neutral flex-between margin-top-8">' +
                '<span class="blur-4 no-user-select">upgrade@featureisnotavailable.com</span>' +
                '<button type="button" class="account-upgrade shiny small"><span>Upgrade my plan</span></button>' +
            '</div>') +
            '<ul class="line-height-150 padding-left-24">' +
                '<li>The subject line will be the feedback title</li>' +
                '<li>The body will be the feedback description</li>' +
                '<li>All email attachments will be attached to the feedback</li>' +
                '<li>AI is used to clean up forwarded emails by removing irrelevant content, making feedback easier to read and act on</li>' +
            '</ul>' +

            '<hr class="small">' +

            '<div class="flex-between-top gap-48">' +
                '<p>Restrict the domains or email addresses from which emails can be forwarded. When this is turned off, emails can be forwarded from any sender.</p>' +
                '<div><button type="button" class="public-forwarding-toggle small ' + (this.model.get('allow_public_email_forwarding') ? 'switch-off' : 'switch-on') + '"></button></div>' +
            '</div>' +

            (this.project_emails === null ?
            '<div class="divider-12"></div>' +
            '<div class="loader-placeholder margin-bottom-8"></div>' +
            '<div class="loader-placeholder margin-bottom-8"></div>' +
            '<div class="loader-placeholder"></div>'

            :

            (this.project_emails.map((project_email) => {
                // TODO: render user id
                return this.getEmailInputTemplate(project_email.value);
            }).join('') +

            (this.project_emails.length === 0 ?
            this.getEmailInputTemplate('') : '')) +

            '<div class="divider-12"></div>' +
            '<div class="flex-between margin-bottom-24">' +
                '<button type="button" class="project-email-add text-primary-small"><i class="fa-solid fa-circle-plus"></i>Add domain or email</button>') +
                '<button type="submit" class="project-email-save primary small" disabled>Save Changes</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        if (this.project_emails === null) {
            this.loadProjectEmail();
        }

        return this;
    }
});